const ErrorComponent = ({ error }: any) => {
  return <h6>An Error Occurred: {error.errorCode}</h6>;
};

export default ErrorComponent;
